import { useRouter } from 'next/router';

import { Box, Page } from '@zillow/constellation-10';

import { useFeedListingIdRedirect } from '../../../../../hooks';
import { getCachedPropertyAddress } from '../../../../../utils/navigationCacheUtils';

import RestrictedListingBanner from '../../../../../components/CreateListingPage/RestrictedListingBanner';
import Navigation from '../../../../../components/Dashboard/Navigation';
import PropertyCard from '../../../../../components/Dashboard/PropertyCard';
import RentGuaranteeBannerMultiPolicy from '../../../../../components/Dashboard/RentGuaranteeBannerMultiPolicy';
import OverviewPage from '../../../../../components/OverviewPage';
import AuthCheckWrapper from '../../../../../containers/AuthCheckWrapper';

const DashboardOverviewPage = () => {
  const router = useRouter();
  const listingAlias = router.isReady ? (router.query.listingAlias as string) : '';

  useFeedListingIdRedirect(listingAlias);

  const cachedAddress = typeof window !== 'undefined' ? getCachedPropertyAddress() : null;

  const skeleton = (
    <Page.Root css={{ backgroundColor: 'bg.softest' }}>
      <Box
        css={{
          backgroundColor: 'bg.neutral',
          borderBottom: '1px solid {colors.border.muted}',
        }}
      >
        <Page.Content
          css={{
            marginBlock: '0',
            paddingTop: { base: '400', md: '800' },
            paddingInline: 0,
          }}
        >
          <Box css={{ marginInline: '400' }}>
            <PropertyCard listingAlias={listingAlias} fallbackAddress={cachedAddress ?? undefined} />
          </Box>
          <Box css={{ marginBottom: '600' }} />
          <Box css={{ marginBottom: '400' }} />
          <Navigation listingAlias={listingAlias} activeTab="overview" />
        </Page.Content>
      </Box>
    </Page.Root>
  );

  return (
    <AuthCheckWrapper loading={skeleton} redirecting={skeleton}>
      <Page.Root css={{ backgroundColor: 'bg.softest' }}>
        <Box
          css={{
            backgroundColor: 'bg.neutral',
            borderBottom: '1px solid {colors.border.muted}',
          }}
        >
          <RestrictedListingBanner isFromDashboard={true} />
          <Page.Content
            css={{
              marginBlock: '0',
              paddingTop: { base: '400', md: '800' },
              paddingInline: 0,
            }}
          >
            <Box css={{ marginInline: '400' }}>
              <PropertyCard listingAlias={listingAlias} fallbackAddress={cachedAddress ?? undefined} />
            </Box>
            <Box css={{ marginBottom: '600' }} />
            <Box css={{ marginBottom: '400' }} />
            <Navigation listingAlias={listingAlias} activeTab="overview" />
          </Page.Content>
        </Box>
        <RentGuaranteeBannerMultiPolicy listingAlias={listingAlias} />
        <Page.Content css={{ marginBlockStart: '400' }}>
          <OverviewPage listingAlias={listingAlias} />
        </Page.Content>
      </Page.Root>
    </AuthCheckWrapper>
  );
};

export default DashboardOverviewPage;
